import {Bar, BarChart, CartesianGrid, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import React from "react";
import {LeaveGraphProps} from "./types/leave-graph-types";
import EmptyData from "../../common/empty-data/empty-data";
import {CalendarX2} from "lucide-react";
import LoadingSkeleton from "../../common/loading-skeleton/loading-skeleton";

const LeaveRequestAnalysisChart = (props: LeaveGraphProps) => {

    const chartData = props.leaveRequestData
        ? [
            {
                name: "Approved",
                value: props.leaveRequestData.approvedRequest,
                fill: 'var( --pn-chart-secondary)'
            },
            {
                name: "Pending",
                value: props.leaveRequestData.pendingRequest,
                fill: 'var(--pn-chart-tertiary)'
            },
            {
                name: "Cancelled ",
                value: props.leaveRequestData.cancelledRequest,
                fill: 'var( --pn-chart-cancelled)'
            },
            {
                name: "Rejected ",
                value: props.leaveRequestData.rejectedRequest,
                fill: 'var(  --pn-chart-quaternary)'
            }
        ]
        : [];

    const CustomTooltip = ({active, payload, label}: { active?: boolean; payload?: { name: string; value: number; color: string }[]; label?: string }) => {
        if (!active || !payload || !payload.length) return null;
        return (
            <div
                style={{
                    background: '#fff',
                    border: '1px solid #E5E7EB',
                    borderRadius: 8,
                    padding: '10px 14px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                    fontFamily: 'DM Sans, sans-serif',
                    fontSize: 12,
                }}
            >
                <div style={{fontWeight: 700, marginBottom: 6, color: '#111827'}}>{label}</div>
                {payload.map((entry) => (
                    <div key={`tooltip-${entry.name}`}
                         style={{display: 'flex', alignItems: 'center', gap: 6, marginBottom: 3}}>
                    <span style={{
                        width: 8,
                        height: 8,
                        borderRadius: 2,
                        background: entry.color,
                        display: 'inline-block'
                    }}/>
                        <span style={{fontWeight: 600, color: '#111827', marginLeft: 2}}>{entry.value}</span>
                    </div>
                ))}
            </div>
        );
    };


    return (
        <div className={"dashboard-leave-chart"} >
            <LoadingSkeleton loading={props.loading}>
                {
                    props?.leaveRequestData ?
                        <section>
                            <ResponsiveContainer width="100%" height={200}>
                                <BarChart
                                    data={chartData}
                                    margin={{top: 8, right: 8, left: -40, bottom: 0}}
                                    barSize={30}
                                    barGap={1}
                                >
                                    <CartesianGrid strokeDasharray="3 3" stroke="#F3F4F6" vertical={false}/>
                                    <XAxis
                                        dataKey="name"
                                        tick={{fontSize: 11, fill: '#9CA3AF', fontFamily: 'DM Sans, sans-serif'}}
                                        axisLine={false}
                                        tickLine={false}
                                    />
                                    <YAxis
                                        allowDecimals={false}
                                        tick={{fontSize: 11, fill: '#9CA3AF', fontFamily: 'DM Sans, sans-serif'}}
                                        axisLine={false}
                                        tickLine={false}
                                    />
                                    <Tooltip content={<CustomTooltip/>} cursor={{fill: 'rgba(37,99,235,0.04)'}}/>
                                    <Bar
                                        dataKey="value"
                                        radius={[3, 3, 0, 0]}
                                    >
                                        {chartData.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={entry.fill}/>
                                        ))}
                                    </Bar>
                                </BarChart>
                            </ResponsiveContainer>
                        </section>
                        :
                        <EmptyData
                            icon={<CalendarX2 className={'leave-request-empty-data-icon'}/>}
                            title={"No Leave Requests Found"}
                            subtitle={"There are currently no pending or past leave requests to review!"}
                        />
                }
            </LoadingSkeleton>
        </div>

    )
}

export default LeaveRequestAnalysisChart;
